const onAdd = (address)=>{
    if(address && address.length > 20 && address.indexOf('0x') > -1){
        return address.slice(0,4) + '…'+ address.substr(-4,4)
    }else{
        return address || 'Please register'
    }
}
// const headers = {
//     'Content-Type': 'application/json',
//     'Domain':'genesis.seer.eco',
//     'Terminal':'web',
//     'Language':'en'
// }
const loginHttp = 'https://hs.cowcow.live/_matrix/client/r0/login'


const onLogin = async(parms)=>{
    let obj = {
        method: 'post',
        headers:{
            'Content-Type':'application/json'
        }
    }
    if(parms){
        obj.body = JSON.stringify(parms)
    }
    try {
        const response = await fetch(loginHttp,obj);
        return response.json();
        // if(response.status == 200){
        //     return response.json();
        // }else{
        //     console.log(response)
        //     console.log(response.message)
        // }
    } catch(err) {
        console.error(err);
    }
}

const Tx=(myadd,fun,succeed,error)=>{  
    fun.send({ from: myadd}, 
    (hash) => {
        console.log(hash)
        if (hash && hash.length > 0) {
            const status_checker = setInterval(async () => {
            const tx = await window.web3js.eth.getTransaction(hash)
            if (!(typeof tx.blockHash == 'object' && tx.blockHash === null)) {
                const txrt = await window.web3.eth.getTransactionReceipt(hash)
                // console.log({ getTransactionReceipt: txrt })
                clearInterval(status_checker)
                switch (txrt.status) {
                    case true:
                    console.log('ok')
                    break
                default:
                    console.log('err')
                    break
                }
            }
            }, 1000)
        }
    }).on('error', function(error){ 
        console.log('error---',error)
    }).then(
        (res) => {
            if (res.status === true) {
            succeed && succeed(res)
            } else {
            error && error(res)
            }
        },
        (failure) => {
            // error && error(failure)
            error && error(failure)
            //alert('failure:'+failure.code+failure.message) //code: 4001, message: user cancelled
        }
    )
}

const verify = async(nonce,UTCseconds,id)=>{
    // console.log("chainId", id)
    var msgParams = {
        domain: {
            chainId: id,
            name: 'SEER',
            verifyingContract: '0x6c106583B7079794Aa80F947FC09FEbc5276c9C5',
            version: '1',
        },
        message: {
            contents:"This request will not trigger a blockchain transaction or cost any gas fees.",
            node: 'genesis.seer.eco',//假节点
            action: "connect",
            nonce:nonce,//用户的Nonce nonces
            stamp:UTCseconds,//时间戳 UTCseconds
          },
          primaryType: 'Login',
          types: {
            EIP712Domain: [
              { name: 'name', type: 'string' },
              { name: 'version', type: 'string' },
              { name: 'chainId', type: 'uint256' },
              { name: 'verifyingContract', type: 'address' },
            ],
            Login: [
              { name: 'contents', type: 'string' },
                    { name: 'node', type: 'string' },
                    { name: 'action', type: 'string' },
                    { name: 'nonce', type: 'uint256' },
                    { name: 'stamp', type: 'uint256' },
            ],
          },
    };
    
    let hash;
    hash = await window.ethereum.request({
        method: 'eth_signTypedData_v4',
        params: [window.ethereum.selectedAddress.toLocaleLowerCase(), JSON.stringify(msgParams)],
    });
    return hash
}



export {onAdd,Tx,verify,onLogin}


// WEBPACK FOOTER //
// ./src/utils/index.js